import React from "react";
import { Button, Form, FormControl, InputGroup } from "react-bootstrap";
import AppComponent from "../../../Components/AppComponent";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import { connect } from "react-redux";
import api from "../../../Services/Api/api";
import RenderAmount from "../../../Components/etc/RenderAmount";
import AppTable from "../../Components/AppTable";
import AccountDetails from "../AccountsScreen/AccountDetails";

const SCREEN_NAME = "REPORTS_SCREEN";

class PnLReportInner extends AppComponent {
  constructor(props) {
    super(props);

    this.state = {
      visibleModal: null,
      modalData: null,
      period: "monthly",
      range0: null,
      range1: null,
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
    };

    const columns = [
      {
        value: "totalReovery",
        label: "Total Recovery Amount",
        render: ({ item }) => (
          <RenderAmount value={item?.totalRecovery || 0} />
        ),
      },
      {
        value: "totalLoanInterest",
        label: "Total Loan Interest",
        render: ({ item }) => (
          <RenderAmount value={item?.totalLoanInterest || 0} />
        ),
      },
      {
        value: "totalInterestRecovered",
        label: "Total Interest Recovered",
        render: ({ item }) => (
          <RenderAmount value={item?.totalInterestRecoverd || 0} />
        ),
      },
      {
        value: "totalCommission",
        label: "Total Commission",
        render: ({ item }) => (
          <RenderAmount value={item?.totalCommission || 0} />
        ),
      },
      {
        value: "totalDepositInterest",
        label: "Total Deposit Interest",
        render: ({ item }) => (
          <RenderAmount value={item?.totalDepositInterest || 0} />
        ),
      },
      {
        value: "totalExpense",
        label: "Total Expense",
        render: ({ item }) => <RenderAmount value={item?.totalExpense || 0} />,
      },
      {
        value: "balance",
        label: "Remaining Balance",
        render: ({ item }) => (
          <RenderAmount
            value={item?.balance || 0}
            style={{
              color:
                item?.balance > 0
                  ? "green"
                  : item?.balance < 0
                  ? "red"
                  : "gray",
            }}
          />
        ),
      },
    ];

    if (this.props.filteredColumns) {
      let newColumns = [];

      for (let i = 0; i < this.props.filteredColumns.length; i++) {
        const colValue = this.props.filteredColumns[i];

        const col = columns.find((x) => x.value === colValue);
        if (col) {
          newColumns.push(col);
        }
      }

      this.columns = newColumns;
    } else {
      this.columns = columns;
    }

    this.months = "January, February, March, April, May, June, July, August, September, October, November, December"
      .split(",")
      .map((x) => x.trim());
  }

  componentDidMount() {
    this.onMount();
    this.onSubmit();
  }

  async onSubmit() {
    try {
      if (this.state.loading) return;
      let range0, range1;
      if (this.state.period === "monthly") {
        let refDate = new Date(this.state.year, this.state.month);

        range0 = refDate.getTime();
        range1 = new Date(refDate).setMonth(refDate.getMonth() + 1);
      } else {
        range0 = new Date(this.state.range0).setHours(0, 0, 0, 0);
        range1 = new Date(this.state.range1).setHours(0, 0, 0, 0);
      }

      this.setAsyncState({ loading: true, error: null });
      const res = await api.get("v1/report/pnl", {
        range0,
        range1,
        accountsWhere: this.props.accountsWhere,
      });

      this.setAsyncState({ data: res, loading: false });
    } catch (e) {
      this.setAsyncState({ loading: false, error: e.message });
    }
  }

  render() {
    const {
      state: { month, year, loading, error, visibleModal, modalData },
      props: { title },
    } = this;

    const content = (
      <div>
        <div className="pagetitlebar">
          <div className="left">
            <div className="title">{title || "Profit and Loss Report"}</div>
          </div>
          <div className="right">
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                this.onSubmit();
              }}
            >
              <InputGroup className="mb-3">
                <FormControl
                  value={month || ""}
                  onChange={(e) => this.setState({ month: e.target.value })}
                  as="select"
                  required
                >
                  <option value="">Select Month</option>
                  {this.months.map((x, i) => (
                    <option key={i} value={i}>
                      {x}
                    </option>
                  ))}
                </FormControl>
                <FormControl
                  type="number"
                  value={year || ""}
                  onChange={(e) => this.setState({ year: e.target.value })}
                  placeholder="Year"
                  required
                />

                <Button disabled={loading} type="submit">
                  Load
                </Button>
              </InputGroup>
            </Form>
          </div>
        </div>

        <div>
          <AppTable
            {...{
              items: this.state.data?.total ? [this.state.data?.total] : [],
              loading,
              error,
              table: {
                columns: this.columns,
                getStyle: ({ item }) =>
                  item._id === "total"
                    ? { color: "blue", fontWeight: "bold" }
                    : null,
                // onRowClick: ({ item, index }) =>
                //   this.setAsyncState({
                //     visibleModal: "transactionDetails",
                //     modalData: { transaction: item, index },
                //   }),
              },
            }}
          />
        </div>

        <AccountDetails
          {...{
            key: `accountDetails-${
              visibleModal === "accountDetails"
                ? modalData?.account?.shortId || "new"
                : "disabled"
            }`,

            renderModal: true,
            visible: visibleModal === "accountDetails",
            shortId: modalData?.account?.shortId,
            handleClose: () => this.setAsyncState({ visibleModal: null }),

            ...(modalData || {}),
          }}
        />
      </div>
    );

    return content;
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const PnLReport = connect(mapStateToProps, mapDispatchToProps)(PnLReportInner);

export default PnLReport;
